import getNumberOfDays from './getNumberOfDays.js';
import transformStudyDateToDate from './transformStudyDateToDate.js';
import findTimepointIndex from './findTimepointIndex.js';

/**
 * @param {array} reports
 * @param {string[]} reports[].date
 * @param {string[]} reports[].result
 * @returns {string}
 */
function getStableTimePeriod(reports) {
  const progressiveIndex = findTimepointIndex(reports, 'progressive');
  if (progressiveIndex >= 0) {
    return null;
  }
  const baselineIndex = findTimepointIndex(reports, 'baseline');
  const baselineDate = transformStudyDateToDate(reports[baselineIndex].date);
  const latestIndex = findTimepointIndex(reports, 'latest');
  const latestDate = transformStudyDateToDate(reports[latestIndex].date);
  return getNumberOfDays(baselineDate, latestDate);
}

export default getStableTimePeriod;
